import { useState } from 'react';
import { indexOf, isEmpty } from 'lodash';
import {
  array, string, func, bool, number,
} from 'prop-types';
import './FilterType.less';

/**
 * 筛选组件
 * @param {string} title 标题
 * @param {array} data 数据源
 * @param {func} onChange
 * @param {bool} radio 是否是单选
 * */

export default function FilterType({
  title, data, onChange, radio, titleWidth = 60,
}) {
  const [select, setSelect] = useState([0]);

  function handleAll() {
    setSelect([0]);
    onChange();
  }

  function handleChange(e) {
    let temp = [...select];
    const current = indexOf(select, e);
    if (current === -1) {
      temp = temp.filter((item) => item !== 0);
      if (radio) { // 是否单选
        temp = [e];
      } else {
        temp.push(e);
      }
    } else {
      temp = temp.filter((item) => item !== e);
    }
    if (isEmpty(temp)) {
      temp = [0];
      onChange();
    } else {
      onChange(temp);
    }
    setSelect(temp);
  }

  return (
    <div className="filter-type">
      <div className="filter-type__row">
        <div className="filter-type__title" style={{ width: titleWidth }}>{title}</div>
        <div className="filter-type__box">
          <div className={`filter-type__row-item ${indexOf(select, 0) !== -1 && 'filter-type__active'}`} key={0} onClick={handleAll}>
            全部
          </div>
          {
            data?.map((item) => (
              <div
                className={`filter-type__row-item ${indexOf(select, item.val || item.id) !== -1 && 'filter-type__active'}`}
                key={item.val || item.id}
                onClick={() => handleChange(item.val || item.id)}
                style={{ fontSize: item.name.length > 11 ? '13px' : '14px' }}
              >
                {item.name}
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

FilterType.propTypes = {
  data: array,
  title: string,
  onChange: func,
  radio: bool,
  titleWidth: number,
};
